const GoogleIcon = ({ className, disabled = false }: { className?: string; disabled: boolean }) => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ opacity: `${disabled ? 0.5 : 1}` }}
    >
      <path
        d="M24 12.5C24 5.87258 18.6274 0.5 12 0.5C5.37258 0.5 0 5.87258 0 12.5C0 19.1274 5.37258 24.5 12 24.5C18.6274 24.5 24 19.1274 24 12.5Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.8723 12.6365C17.8723 12.211 17.8341 11.8019 17.7632 11.4092H12.1123V13.7301H15.3414C15.2023 14.4801 14.7796 15.1156 14.1441 15.541V17.0465H16.0832C17.2178 16.0019 17.8723 14.4637 17.8723 12.6365Z"
        fill="#4285F4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.1123 18.5C13.7323 18.5 15.0905 17.9628 16.0832 17.0464L14.1441 15.5409C13.6069 15.9009 12.9196 16.1137 12.1123 16.1137C10.5496 16.1137 9.22686 15.0582 8.75504 13.64H6.75049V15.1946C7.73776 17.1555 9.76686 18.5 12.1123 18.5Z"
        fill="#34A853"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.75504 13.64C8.63504 13.28 8.56686 12.8954 8.56686 12.5C8.56686 12.1045 8.63504 11.72 8.75504 11.36V9.80542H6.75049C6.34412 10.6154 6.1123 11.5318 6.1123 12.5C6.1123 13.4682 6.34412 14.3845 6.75049 15.1945L8.75504 13.64Z"
        fill="#FBBC05"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.1123 8.88637C12.9932 8.88637 13.7841 9.1891 14.406 9.78364L16.1269 8.06273C15.0878 7.09455 13.7296 6.5 12.1123 6.5C9.76686 6.5 7.73776 7.84455 6.75049 9.80546L8.75504 11.36C9.22686 9.94183 10.5496 8.88637 12.1123 8.88637Z"
        fill="#EA4335"
      />
    </svg>
  );
};

export default GoogleIcon;
